<template>
    <div>
        <div style="padding: 10px 8px;">
            <div style="border: solid 1px #BBBBBB;">
                <div class="color101010" style="padding: 16px 14px 28px;">
                    <div @click="goIncomeManage()">
                        我的收益
                        <i class="fa fa-angle-right color686868 floatR"></i>
                    </div>
                    <div style="margin-top: 24px;">
                        <div class="flexLayout font14r">
                            <div class="flexItem">
                                <div class="color777">
                                    今日收入
                                    <i class="icon eyeOpenedIcon size24 alignM" style="margin-top: -2px;"
                                       v-if="showTodayIncome" @click="showTodayIncome=!showTodayIncome"></i>
                                    <i class="icon eyeClosedIcon size24 alignM" style="margin-top: -2px;"
                                       v-else @click="showTodayIncome=!showTodayIncome"></i>
                                </div>
                                <div class="color101010" style="margin-top: 32px; min-height: 20px;">
                                    <template v-if="showTodayIncome">￥{{dataItem ? dataItem.todayIncome : ''}}</template>
                                    <template v-else>******</template>

                                </div>
                            </div>
                            <div class="flexItem">
                                <div class="color777">
                                    <span>钱包（可提现）</span>
                                    <i class="icon eyeOpenedIcon size24 alignM" style="margin-top: -2px;"
                                       v-if="showTotalIncome" @click="showTotalIncome=!showTotalIncome"></i>
                                    <i class="icon eyeClosedIcon size24 alignM" style="margin-top: -2px;"
                                       v-else @click="showTotalIncome=!showTotalIncome"></i>
                                </div>
                                <div class="color101010" style="margin-top: 32px; min-height: 20px;">
                                    <template v-if="showTotalIncome">￥{{dataItem ? dataItem.totalIncome : ''}}</template>
                                    <template v-else>******</template>
                                </div>
                            </div>
                        </div><!-- end .flexLayout -->

                        <div class="alignC" style="margin-top: 22px;">
                            <button class="withdrawCashButton" v-show="!isExpired()"
                                @click="withdrawCash()">我要提现</button>
                        </div>
                    </div>
                </div>

            </div>
        </div>

<!--        <div style="padding: 4px 12px 10px;">我的课程订单明细</div>-->

<!--        <div style="padding: 0 15px;">-->
<!--            <div class="filterArea" >-->
<!--                <div style="padding: 10px; border: solid 1px #B8BCC5;">-->

<!--                    <i class="icon clockIcon size24"></i>-->

<!--                    <el-date-picker class="alignC noBorder noBg" style="width: 100px;" type="date"-->
<!--                        v-model="startTime" placeholder="开始" @change="filterByDateRange()"/>-->

<!--                    至-->

<!--                    <el-date-picker class="alignC noBorder noBg" style="width: 100px;" type="date"-->
<!--                        v-model="endTime" placeholder="结束" @change="filterByDateRange()"/>-->
<!--                </div>-->

<!--                <div class="flexLayout font14r marginT16" style="line-height: 34px;">-->
<!--                    <div class="alignC color101010" style="width: 90px;">-->
<!--                        订单类型：-->
<!--                    </div>-->
<!--                    <div class="flexItem">-->
<!--                        <select class="selectbox" v-model="filters.distributionType" @change="reloadDataList()">-->
<!--                            <option value="">全部</option>-->
<!--                            <option v-for="orderTypeItem in orderTypeList" :key="orderTypeItem.code"-->
<!--                                    :value="orderTypeItem.code">-->
<!--                                {{orderTypeItem.title}}-->
<!--                            </option>-->
<!--                        </select>-->
<!--                    </div>-->
<!--                </div>-->

<!--                <div class="flexLayout font14r marginT12" style="line-height: 34px;">-->
<!--                    <div class="alignC color101010" style="width: 90px;">-->
<!--                        分销成员：-->
<!--                    </div>-->
<!--                    <div class="flexItem">-->
<!--                        <input type="text" class="inputbox" placeholder="请输入分销成员姓名" v-model="filters.subordinateName"-->
<!--                           @change="reloadDataList()"/>-->
<!--                    </div>-->
<!--                </div>-->

<!--            </div>-->

<!--            <div class="marginT8" style="border: solid 1px #B8BCC5;" v-for="listItem in dataList" :key="listItem.orderId">-->
<!--                <div style="padding: 10px;">-->
<!--                    <div class="color101010 font14r">订单号：{{listItem.orderId}}</div>-->
<!--                    <div class="color101010 font14r marginT16" style="line-height: 20px; height: 40px;">-->
<!--                        产品名称：{{listItem.productName}}-->
<!--                    </div>-->
<!--                    <div class="marginT16 color101010 font14r flexLayout">-->
<!--                        <div class="flexItem">购买人：{{listItem.payUserName}}</div>-->
<!--                        <div class="flexItem alignR">购买人账号：{{listItem.payUserIntroduceCode}}</div>-->
<!--                    </div>-->
<!--                    <div class="marginT16 font14r flexLayout">-->
<!--                        <div class="flexItem orange">订单收入：￥{{listItem.orderIncome}}</div>-->
<!--                        <div class="flexItem alignR">实付款：￥{{listItem.actualPayment}}</div>-->
<!--                    </div>-->
<!--                    <div class="marginT16 font14r flexLayout">-->
<!--                        <div class="flexItem">订单类型：{{listItem.orderType}}</div>-->
<!--                        <div class="flexItem alignR">-->
<!--                            分销员：{{listItem.salesmanName}}-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="marginT16 font14r">-->
<!--                        购买时间：{{formatDateTime(listItem.createTime)}}-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->

<!--            <div class="alignCenter colorCCC bold paddingV16" v-show="status == 'ready' && dataList.length < 1">-->
<!--                <img src="notice/no_content.png" width="206" height="143" alt="暂时没有任何内容" />-->
<!--            </div>-->

<!--            <div class="paddingV16 alignCenter font14r colorCCC"-->
<!--                 v-show="status=='ready' && pagination.current == pagination.totalPage"-->
<!--                 :data-current="pagination.current" :data-total="pagination.totalPage || 0">-->
<!--                没有更多记录了-->
<!--            </div>-->

<!--        </div>-->

    </div>
</template>

<script>

import generalCmpPart from "@comp/part/generalCmpPart";

import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import appHelper from "@util/appHelper";
import moment from "moment";
import consoleApi from "@comp/platformApi/consoleApi";
Vue.use(ElementUI);

// config and data
import distributionTypeEnum from './distributionTypeEnum';

// api
import userApi from '@/api/user';

const config = {
    apiConfig : {
        list : {
            url : 'portal/v2/distribution/salesman/getOrderList',
            dataPath : 'data.records',
            totalPath : 'data.total',
            totalPagePath : 'data.pages',
        },
        get : {
            url: 'portal/v2/distribution/salesman/get/info'
        },
    },
    withdrawCash : {
        minLimit : 500
    }

}

export default {
    extends : generalCmpPart,
    data() {
        return {
            apiConfig: config.apiConfig,

            enableDataList : true,

            enableDataItem : true,
            autoLoadDataItem : true,

            showTodayIncome : false,
            showTotalIncome : false,

            // type : Date | null
            startTime : null,
            endTime : null,

            filters : {
                // type: String
                startTime : '',
                endTime : '',
                distributionType : '',
                subordinateName : '',
            },

            orderTypeList : distributionTypeEnum.getList(),
            isCompleteIdInfo : false
        }
    },
    methods : {
        onLoadDataItem() {
            this.loadDataList();

            consoleApi.log('[incomeDetail] createTime: ' + this.formatDateTime(this.dataItem.createTime));
            consoleApi.log('[incomeDetail] expireTime: ' + this.formatDateTime(this.dataItem.expireTime));
        },
        goIncomeManage() {
            appHelper.goToPage('distributorIncomeManage');
        },
        filterByDateRange() {

            if (this.startTime)
            {
                this.filters.startTime = this.startTime.getTime();
            }
            else
            {
                this.filters.startTime = '';
            }

            if (this.endTime)
            {
                this.filters.endTime = this.endTime.getTime() + (23 * 3600 + 59 * 60 + 59) * 1000;
            }
            else
            {
                this.filters.endTime = '';
            }

            this.reloadDataList();
        },
        withdrawCash() {

            if (!this.isCompleteIdInfo)
            {
                appHelper.confirm({
                    title : '身份认证',
                    content : '亲爱的小主，为了保证您的提现更加有保障，希望<br/>您进行身份认证，非常感谢！',
                    okText : '去认证',
                    cancelText : '我再想想',
                }, (result) => {

                    if (!result)
                    {
                        return;
                    }

                    appHelper.goToPage('idCardAuth');
                });

                return;
            }

            if (this.dataItem.totalIncome < this.dataItem.limitAmount)
            {
                appHelper.showHint('抱歉，您还未满' + this.dataItem.limitAmount + '元暂不支持提现！');
                return;
            }
            else if ( moment().isBefore(moment(this.dataItem.createTime).add(30, 'days'))  )
            {
                appHelper.showHint('抱歉，您还未满30天分销员暂不支持提现！');
                return;
            }
            appHelper.goToPage('distributorWithdrawCash');
        },

        isExpired()
        {
            if (!this.dataItem)
            {
                return false;
            }

            if (this.dataItem.expireTime < new Date().getTime())
            {
                return true;
            }

            return false;
        }

    },
    mounted() {
        userApi.isCompleteIdInfo((data) => {
            this.isCompleteIdInfo = data;
        });
    }
}
</script>

<style lang="scss" scoped>
.color101010 {
    color: #101010;
}
.color686868 {
    color: #686868;
}
.color777 {
    color: #777;
}
.orange {
    color: #F4950E;
}
.eyeOpenedIcon {
    background-image: url('data:image/png;base64,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');
}
.eyeClosedIcon {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAEDklEQVRoQ+2XW0gUcRTGWy+b61oQRBhEvnSBMqMskMqXqIgIXwKJguqhgpBMxdX1IZCC9up2IV8kCioKJIgeEqweguhC0YVUopfEohsFFdkuZWq/s8wu4+7Mju6MhjADf3Yu5/J953z/yzpmTPPLMc3xz7AJ/O8O2h2wO2CyAraETBbQtLvdAdMlNBnA7oDJApp2n/4daG1tzSssLNwzMjLyxOv19pguyRQE8Pv9K3Nycsqj0ehFRyAQuOFwOKqUvEGPx+PleXQKcEw4BcXOodg+HJsU5+uOYDA4yINbFa0LdnsbGxu/TjjDJDqEw+G5qOQqKTap0sSEwBleHFbnHh0d/clzCCIROvJrEnEZhqbqFL2wDkyijFkpOM/GJzEkDmJwGoOCFIMvvAujtbMEihpms9BAgLtcrkPkF7nMS8EV5X19U1NTR3IVYi4sxeg8H9al4oDcF/nGuNDc3PzaQpxpoSjmYl7uY+xPBa4YPwPPrgSOtGWUGb4TEiHGAi2gOD9GWl18u1VSUvK4urp62Ayhzs7O3IGBgTXoewtxtpG3QifvH74dRw1+uvM3YaO5D2BQgO5qMTrGmJkBYAxCfXzv4bcXYr35+fk99fX1H7V8qG4xIEqHh4fLsF2OzQpGKcNlUITLxD9B1V+l2uluZJFIxDU0NPSEhJLof16fILyspaXlmxYITQIK+Dsa86GLSpTyfuEkMRI5yqo3Wx1fuozEKrVIpBHQAk+Ab4DeyKx/IYF9Pt+qvLy8KoJK+yv05ss4SL7H5pHIjxgPiHmvoaEhxjxczvM9xpxEDD0SYwi0t7cXDQ4OdqsrL+AZlRwzROtpF8nWoef7qkRvuL+kA36zOrbcs8881Ik7LhJJAsqGcZdga1VgMoIXOwgcgEBHwoeurIfsAy1QbW1tS9Czehk+QFfP6XVKrxNOp3MDC8V38UsSYIXwijomAl5s8TvFz5GEH1Ut0tu9Zcns7++XTcip2J+EQEMmqWmRwD6Mn2cMATayZgL75aWRbNQJIXCb5/j5BL+3LHUlmQCR5yV5ZPkU+27st2ayV7qcKqd0AoqEGnGoRAZ1eppPTQagDwCarwC6CaDtBgSuYr9TsXlHJce1orFwLMrNzfVA+jOjDXw/xnTAqApa30OhkJtgcpqNX9wHICBS1L0gfBQCskHGL7fbPaumpiYZY6I4TP0jQz6rSfg0kRRgu9H/lUwg8NnB92sJG7pdZuaPlCkCyM7JkUMIlMoRPBaLFRudWpWuyVIrJ8yXnG3K1WebKe2AJBMSHHulE33IR/5HGF7KUbkMv+e1tbW/DR0yGJjqgJnEVvnaBKyqZLZx7A5kWzmr/OwOWFXJbOPYHci2clb52R2wqpLZxrE7kG3lrPKb9h34B0a8zdJOyP3fAAAAAElFTkSuQmCC');
}
.clockIcon {
    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAE5ElEQVRoQ+2YbYhUVRjHndldtVHWF7DyDTRRCRILMdNIk+1DCtqHJBQsTIxBRsh2d3Z2V8oJbF9mm91citogyxA/KEEmlbAf0vUVX1BLENJKDNtCo13RnWabl35P3oVl2J3znLkzhDAXDufce875/5//8zz3nHOvZ8R9fnnuc/tHFAX83xEsRqAYAZceKKaQSwe6np63CDQ0NEzyer0VHo/nOayaR3mQ9uR0Op2kvkndTX2Gek8oFDrt2nIHwLWA1tbWiYlEYgeG+THQK7i0U7Rv0fydEuP+IRFDe5TDe4X7aHl5+S6/3/+PGzGuBEQikVcwrh1jxlH/Tb0PY76iPhQMBu8ONox+D+MX8Gw1/eupZ0pUKFtra2tlXk5XTgLC4fBIn8/3Hoyb7zk8vZe6htT4TWNFR0dHWW9v7xbmbXfE1zK3WTM3c4y1AIe8E6BlGNBP3r+Etw/kQk5EHpaIURZSIjU1NSFbHGsBkH4EiZ9yG+89j/EnhyNtbm7+nj4v3n1suDFEs5Rofkr/ehyygbG7bURYCcCgVzF6l+Q7pYLcPZGNDLFp6cezWXkkqj09PV1gLyCiT1dXV5/RilALaG9vL4/FYtcgmQD4Goz6wkSiFSA4OGcK2JdpXu/r65tPZFImfOlXC4CgCQLJ0SMY/6wG3EaAI2IbHLIkbyKVPtFwqAQ4q04PgA9QnkDABQ24rQB4RvM+/Ar2XThmaDhUAjBkJWBf45mLeOZxDbCMsRXgzJHl+XW4FsJ11sSlEkD6fExoXwP0bUDDJtCB/lwEtLS0LIbnBKURrnoTl1bAcQQsoSxn2TxsAnUjwNln4mB8RxpVmLhUAvDkzwDNTCaTs+vq6q6aQN0IcNLoJvUtBDxq4lIJIIVieH80y1sZL1rCBJopIJVKPcOeccxi3g+k0HRSaLxpjkoAEfgToImIGJt5SMtGgPCfmPOIM+YgRmFTSNb6rBd8PzoCZNXLeqkEyJEAQ+aRQrNIIUkn1cULOQbvy9pezYQy55j9eUlJyVtVVVWyXA55IeAvxvYhdqqJSCvgG4xYAdhS8vKoCTSzH4NmYVArGKulTw6BVLLKhIcay7OrjDlN/yITl1ZAFeTvArYDAW+aQIfrJ5LyxfYh/bNlTGlpqa+ysjI2ePzAeYtnO+HaauJSCWhsbJxB2H8B7Aqgc0yg2fqd0+dGPBwf6uTZ1NQ0H5G7KRs0O75KgBiEZ04C+hTNFQAfciMin3PVAsjjZRAftj1O5NPYobDUAmQyIr6keoGyhSh8UGjjNPhWAtra2ib39/dfJJXGE4ml5PApDUkhx1gJcN6FJxHQRbsXEavc/uPh3XoZLPnWkG/inbZirQU4ImQ930/xQlzJ7vw+9X+fj9qL1Yijvy/C+ABF/g2t03zlZeLnJEBA5NjLLvut81tE0iqAAcc1AniX1hG9KHPkZ9cNdvhV7PDnNXPzJkCAotHoHP7KvYMhL3IrzriEYQe478SoG2xU3TKOZ1Oo5EeW7OZr6J9273H6M8YF6+vr5ayV05VzBAazkcdzMeoNDForETFYkmRcFxtjkL8P53KyetCkvAgYwOPPxah4PL6S1FqMkEkYKimSoP0H7W5+mZwj7zsDgcAdt4YPzM+rgHwZZYNTFGDjrUKMLUagEF61wSxGwMZbhRhbjEAhvGqD+S9ciC9PcfzmVgAAAABJRU5ErkJggg==');
}
.withdrawCashButton {
    width: 260px;
    height: 37px;
    line-height: 37px;
    padding: 0;
    border-radius: 19px;
    font-size: 14px;
    text-align: center;
    background: transparent;
    border: 1px solid rgba(254, 162, 23, 100);
    color: rgba(254, 162, 23, 100);
}
.filterArea {
    .selectbox, .inputbox {
        display: block;
        width: 100%;
        height: 34px;
        line-height: 34px;
        padding: 0 10px;
        box-sizing: border-box;
        border: 1px solid rgba(187, 187, 187, 100);
        background: transparent;
    }
}
</style>
